<template>
  <nav class="navbar navbar-default">
    <div class="navbar-inner">
      <ul class="nav navbar-nav vld-parent">
        <loading
          :active="loadingLibraries"
          :is-full-page="false"
          :height="30"
        ></loading>
        <li v-for="l in libraries" :key="l.id" :class="{active: l.active}">
          <a @click="changeLibrary(l.id)"
            >{{ $t(`libraries.${l.id}`) }}
            <span v-if="l.size > 0" class="badge badge-info">{{
              l.size
            }}</span></a
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {debounce} from 'lodash';
import Loading from 'vue-loading-overlay';

export default {
  name: 'Toolbar',
  components: {
    Loading
  },
  computed: {
    ...mapState({
      libraries: state => state.libraries,
      loadingLibraries: state => state.loadingLibraries
    })
  },
  methods: {
    ...mapActions(['changeLibrary'])
  },
  created: function () {
    // debounce must be declared inside a lifecycle hook
    // because the resulting function must be bound to the resulting
    // instance of the component
    this.selectLibrary = debounce(function (libraryId) {
      this.changeLibrary(libraryId);
    }, 500);
  },
  props: {
    title: String,
    libraryNames: Object
  }
};
</script>

<style scoped>
li {
  cursor: pointer;
}
a .navbar-brand {
  cursor: none;
}
li.active > a {
  background-color: #81c784 !important;
  color: white !important;
}
.badge {
  background-color: #337ab7;
  color: white;
  padding-top: 4px;
}
.navbar {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-color: #f8f8f8;
}
nav {
  border-top: 0;
}
</style>
